// extracted by mini-css-extract-plugin
module.exports = {"timeline":"styles-module__timeline___2sjAR","timelineSegments":"styles-module__timelineSegments___3bPrE","timelineSegment":"styles-module__timelineSegment___2MlUs"};